import React from "react";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";

export const CreateFeatureButton = props => (
  <div>
    <Button variant="outlined" color="default" onClick={props.toggleDialog}>
      <AddIcon
        style={{ height: 16, width: 16, marginRight: 5 }}
      />
      {languages.features.create}
    </Button>
  </div>
);
